import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=13f318f6&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=ts&"
export * from "./Slider.vue?vue&type=script&lang=ts&"
import style0 from "./Slider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Slider.vue?vue&type=style&index=1&id=13f318f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f318f6",
  null
  
)

export default component.exports